import { async } from '@angular/core/testing';
import { Component, OnInit, TemplateRef, enableProdMode, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors, FormsModule, Form } from '@angular/forms';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { CampaignService } from './../campaign.service';
import { Campaign } from './../campaign.model';
import { sortBy, get, lowerCase, includes, chain } from 'lodash';
import { BsModalService, TimepickerModule } from 'ngx-bootstrap';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { unescape } from 'lodash';
import { Encoder } from '../../../utils/encoder';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { providerDef } from '@angular/core/src/view';
import { isObject } from 'util';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { htmlToText } from 'html-to-text';
enableProdMode();

@Component({
  selector: 'app-campaign',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class CampaignFormComponent implements OnInit,OnDestroy {
  campaignForm: FormGroup;
  provider: FormControl;
  id: FormControl;
  name: FormControl;
  description: FormControl;
  country: FormControl;
  timezone: FormControl;
  currencyCode: FormControl;
  brandName: FormControl;
  skuType: FormControl;
  grossBuget: FormControl;
  startDate: FormControl;
  endDate: FormControl;
  costBasic: FormControl;
  costValue: FormControl;
  objective: FormControl;
  objectiveValue: FormControl;
  ageFrom: FormControl;
  ageTo: FormControl;
  currencyFrom: FormControl;
  currencyTo: FormControl;
  gender: FormControl;
  impAttri: FormControl;
  asGroup: FormControl;
  collectSample: FormControl;
  receiveFromCds2: FormControl;
  sendToCds2: FormControl;
  clientId: FormControl;
  segment: FormControl;
  segmentCategory: FormControl;
  forever: FormControl;
  apiKey: FormControl;
  campaignType: FormControl;
  pinpoint: FormControl;

  email: FormControl;
  phone: FormControl;
  sms: FormControl;
  whatsapp: FormControl;
  body: FormControl;
  subject: FormControl;
  experienceName: FormControl;
  modalRef: BsModalRef;
  timeZoneList: Array<string>;
  currencyCodeList: Array<string>;

  regionList: Array<any>;
  countryList: Array<any>;
  buList: Array<any>;
  partyList: Array<string>;
  genderList: Array<string>
  filteredTimeZones: Observable<String[]>;
  isAsGroup: boolean;
  isCollectSample: boolean;
  isReceiveFromCds2: boolean;
  isSendToCds2: boolean;

  showAlert = false;
  errorMessage: string = null;

  campaign: Campaign = new Campaign();
  isEditing: boolean;

  createdCampaignId: string;
  deleteModalRef: BsModalRef;
  loading: boolean = false;
  judgeDateValue: boolean = false;
  foreverEnd: boolean = false;
  viewCode: boolean = true;
  cokieCode: string;
  verifiSave: boolean;
  ifDateRequire: boolean;
  segmentCatList: Array<any> = [];
  segmentList: Array<any> = [];

  brandList: any;
  cookieBrandList: any;

  htmlStrValidate: string = '';
  isEmail: boolean;
  isPhone: boolean;
  isSms: boolean;
  isWhatsapp: boolean;
  subjectContent: string;
  emailTemplateHtmlContent: string;
  emailTemplateTextContent: string;
  editor: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private campaignService: CampaignService,
    private modalService: BsModalService
  ) { }

  ngOnDestroy(): void {
    tinymce.remove("#body");
  }

  ngOnInit() {
   
  }

  onChangeCountry(countryIndex: number) {
  }

  getBrandList() {
    this.campaignService.getBrandList().subscribe(res => {
      if (res) {
        this.brandList = res;
        this.brandList = this.brandList.sort();
        this.cookieBrandList = JSON.parse(JSON.stringify(this.brandList));
      }
    })
  }

  getExperienceName() {
    if (this) {
      return `${this.provider.value.region}_${this.provider.value.bu}_${this.provider.value.country}_${this.campaign.campaignId}`;
    }
    return undefined;
  }

  
  getLocalDate(time) {
    let date = new Date(time);
    const day = date.getUTCDate();
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    return new Date(year, month, day);
  }


  filterTimeZone(name: string): String[] {
    return this.timeZoneList.filter(option =>
      option.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  private getPartiesList(): Array<string> {
    return get(this.activatedRoute, ['snapshot', 'data', 'parties'], []);
  }


  integerValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }
    return ((parseFloat(value) == parseInt(value)) && !isNaN(value)) ? null : { 'integer': true };
  };

 

  createForm() {
    this.campaignForm = new FormGroup({
      provider: this.provider,
      id: this.id,
      name: this.name,
      country: this.country,
      description: this.description,
      timezone: this.timezone,
      currencyCode: this.currencyCode,
      brandName: this.brandName,
      skuType: this.skuType,
      grossBuget: this.grossBuget,
      startDate: this.startDate,
      endDate: this.endDate,
      costBasic: this.costBasic,
      costValue: this.costValue,
      objective: this.objective,
      objectiveValue: this.objectiveValue,
      ageFrom: this.ageFrom,
      ageTo: this.ageTo,
      currencyFrom: this.currencyFrom,
      currencyTo: this.currencyTo,
      gender: this.gender,
      impAttri: this.impAttri,
      segmentCategory: this.segmentCategory,
      segment: this.segment,
      asGroup: this.asGroup,
      collectSample: this.collectSample,
      receiveFromCds2: this.receiveFromCds2,
      sendToCds2: this.sendToCds2,
      clientId: this.clientId,
      forever: this.forever,
      apiKey: this.apiKey,
      campaignType: this.campaignType,
      pinpoint: this.pinpoint,
      email: this.email,
      phone: this.phone,
      sms: this.sms,
      whatsapp: this.whatsapp,
      subject: this.subject,
      body: this.body,
      experienceName: this.experienceName
    });
  }

  

  GetUTCDateTimestamp(time) {
    const date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth();
    let day = date.getDate();
    return Math.floor(Date.UTC(year, month, day) / 1000);
  }

  

  transformSegment(campaign) {
    let arrSegment = [], arrSegmentCat = [];
    const findData = (validation, list, arr) => {
      validation.split(',').forEach(result => {
        const data = list.find(segment => segment.segment_name == result);
        if (data) {
          arr.push(data.segment_value);
        }
      });
    }
    findData(this.segment.value, this.segmentList, arrSegment);
    findData(this.segmentCategory.value, this.segmentCatList, arrSegmentCat);
    if (arrSegment.length) {
      campaign.segment = arrSegment.toString();
    }
    if (arrSegmentCat.length) {
      campaign.segmentCategory = arrSegmentCat.toString();
    }
  }

  navigateToEdit() {
    this.router.navigate(['/campaigns/edit', { campaignId: this.createdCampaignId }]);
  }

  errorMessageClose(): void {
    this.showAlert = false;
    this.errorMessage = '';
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true })
      .then(() =>
        this.router.navigate([uri]));
  }


  deleteShowModal(template: TemplateRef<any>): any {
    this.deleteModalRef = this.modalService.show(template, {
      ignoreBackdropClick: true
    });
  }


  private dirtyForm(form: FormGroup) {
    Object.keys(form.controls).forEach(key => {
      const control = form.controls[key];

      if (control instanceof FormGroup) {
        return this.dirtyForm(control);
      }

      control.markAsDirty();
    });
  }

  verifiData(data) {
    if (this.timeZoneList) {
      this.verifiSave = false;
      this.timeZoneList.forEach(el => {
        if (el == data) {
          this.verifiSave = true;
        }
      })
    } else {
      this.verifiSave = true;
    }
  }

  judgeDate(bol, source) {
    let date = source.target.value;
    const curryDate = new Date(date).getTime();
    if (bol) {
      let endValue = this.endDate.value;
      let end = new Date(endValue).getTime();
      !isNaN(end) && curryDate > end ? this.judgeDateValue = true : this.judgeDateValue = false;
    } else {
      let startValue = this.startDate.value;
      let start = new Date(startValue).getTime();
      !isNaN(curryDate) && start > curryDate ? this.judgeDateValue = true : this.judgeDateValue = false;
    }
  }

  isForevry() {
    if (this.foreverEnd) {
      this.endDate.setValue('');
      this.ifDateRequire = false;
    }
    this.judgeDateValue = false;
  }

  showApiKey() {
    if (this.viewCode) {
      this.apiKey = new FormControl(this.cokieCode);
      this.viewCode = !this.viewCode;
    } else {
      this.cokieCode = this.apiKey.value;
      this.apiKey = new FormControl('*****************');
      this.viewCode = !this.viewCode;
    }
  }

  shooseBrand(data) {
    if (this.brandName.value.indexOf(data) > -1) {
      return false;
    }
    const comma = this.brandName.value ? ',' : '';
    const brandValue = `${this.brandName.value}${comma}${data}`;
    this.brandName.setValue(brandValue);
  }

  noInputBrand(e: any) {
    if (e.keyCode != '8') {
      this.brandList.sort((a) => {
        return a[0] == e.key.toUpperCase() ? -1 : 1;
      });
      return false;
    }
    const index = this.brandName.value.lastIndexOf(',');
    const brandValue = this.brandName.value.substring(0, index + 1);
    this.brandName.setValue(brandValue);

  }

  private getSegmentList() {
    const list: Array<any> = JSON.parse(localStorage.getItem('segmentList'));
    const getAllData = () => {
      this.campaignService.getSegmentList().subscribe(res => {
        this.segmentCatList = this.segmentCatList.concat(res['items']);
        if (res['nextPageKey']) {
          getAllData();
        } else {
          this.segmentCatList = this.segmentCatList.filter(result => {
            if (!result.parent) {
              result.son = [];
              this.segmentCatList.forEach(value => {
                if (value.parent == result.segment_value) {
                  result.son.push(value);
                }
              })
              return result;
            }
          })
        }
        localStorage.setItem('segmentList', JSON.stringify(this.segmentCatList));
      })
    }
    if (list) {
      this.segmentCatList = list;
      return;
    }
    getAllData();
  }

  pushSegmentData(list) {
    if (this.segmentCategory.value) {
      const catList = [];
      const arr = this.segmentCategory.value.split(',');
      list.forEach(data => {
        const result = arr.find(segment => segment == data.segment_value);
        if (result) {
          catList.push(data.segment_name);
          this.segmentList = this.segmentList.concat(data.son);
        }
      });
      if (catList.length) {
        this.segmentCategory.setValue(catList.toString());
      }
    }
    if (this.segment.value) {
      const arr = this.segment.value.split(',');
      const segList = [];
      this.segmentList.forEach(data => {
        const result = arr.find(segment => segment == data.segment_value);
        if (result) {
          segList.push(data.segment_name);
        }
      });
      if (segList.length) {
        this.segment.setValue(segList.toString());
      }
    }
  }

  selectSegment(list, type) {
    const selectType = type ? this.segmentCategory : this.segment;
    if (type) {
      this.segmentList = this.segmentList.concat(list.son);
    }

    if (selectType.value.indexOf(list.segment_name) > -1) {
      return false;
    }
    const comma = selectType.value ? ',' : '';
    const value = `${selectType.value}${comma}${list.segment_name}`;
    selectType.setValue(value);
  }

  noInputSegment(e, type) {
    const selectType = type ? this.segmentCategory : this.segment;
    const list = type ? this.segmentCatList : this.segmentList;
    if (e.keyCode != '8') {
      list.sort((a) => {
        return a.segment_name[0] == e.key.toUpperCase() ? -1 : 1;
      });
      return false;
    }
    const index = selectType.value.lastIndexOf(',');
    if (type) {
      //delete the field which was typed
      const name = selectType.value.substring(index + 1, selectType.value.length);
      const deleteList = this.segmentCatList.find(result => result.segment_name == name);
      let valueList = this.segment.value.split(',');
      valueList = valueList.filter(name => {
        if (!deleteList.son.find(result => result.segment_name == name)) {
          return name
        }
      });
      this.segment.setValue(valueList.join(','));
      //delete the same list
      this.segmentList = this.segmentList.filter(segment => {
        const data = deleteList.son.find(result => result.segment_value == segment.segment_value);
        if (!data) {
          return segment;
        }
      });
    }
    const value = selectType.value.substring(0, index + 1);
    selectType.setValue(value);
  }

  checkHtml(htmlStr: string): boolean {
    let reg = /<[^>]+>/g;
    return reg.test(htmlStr);
  }

  checkInputValue(e) {
    return this[e.target.id].value = e.target.value = e.target.value.replace(/[^a-zA-Z0-9_\- ]||/g, '');
  }

  ngAfterViewInit() {
    if (this.editor) return;
    tinymce.init({
      selector: '#body',
      plugins: [
        'advlist autolink lists link charmap print preview hr anchor pagebreak media',
        'searchreplace wordcount visualblocks visualchars code fullscreen ',
        'insertdatetime nonbreaking save table contextmenu directionality ',
        'paste textcolor colorpicker textpattern'
      ],
      height:"380",
      image_advtab: true,
      menubar: true
    });

  }



}



// WEBPACK FOOTER //
// ./src/app/modules/campaign/form/form.component.ts